import { Check } from 'lucide-react';
import { Reveal } from './Reveal';
import { DemoCta } from './CtaButtons';
import { LANDING_ANCHORS, LANDING_PRICING, LANDING_PRECO_PERSONALIZADO } from '../../domain/landingContent';

const TRANS = 'transition-all duration-500 ease-[cubic-bezier(0.32,0.72,0,1)]';

/** Tabela de preços / planos. */
export function LandingPricing() {
  return (
    <section
      id={LANDING_ANCHORS.precos}
      className="mx-auto max-w-6xl scroll-mt-24 px-4 py-24 sm:px-6 sm:py-32"
    >
      <Reveal className="mx-auto max-w-2xl text-center">
        <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
          Escolha o porte da sua operação
        </h2>
        <p className="mt-3 text-sm text-slate-400 sm:text-base">
          Sem licença por tela. Valores sob consulta conforme número de unidades e módulos.
        </p>
      </Reveal>

      <div className="mt-12 mx-auto grid max-w-3xl gap-4 lg:grid-cols-2">
        {LANDING_PRICING.map((tier, i) => (
          <Reveal key={tier.id} delay={i * 0.06} className="h-full">
            <article
              className={`${TRANS} flex h-full min-w-0 flex-col rounded-[2rem] border p-6 motion-reduce:transition-none sm:p-7 ${
                tier.destaque
                  ? 'border-orange-500/30 bg-gradient-to-b from-orange-500/10 to-transparent shadow-lg shadow-orange-500/5'
                  : 'border-white/[0.06] bg-white/[0.03]'
              }`}
            >
              {tier.destaque && (
                <span className="mb-4 inline-flex w-fit rounded-full bg-orange-500/20 px-3 py-1 text-xs font-semibold text-orange-300">
                  Mais popular
                </span>
              )}
              <h3 className="min-w-0 break-words text-xl font-bold text-white">{tier.nome}</h3>
              <p className="mt-1 break-words text-sm text-slate-400">{tier.publico}</p>
              <p className="mt-6 break-words text-3xl font-black tabular-nums tracking-tight text-white">{tier.preco}</p>
              {tier.precoNota && (
                <p className="mt-1 text-xs text-slate-500">{tier.precoNota}</p>
              )}

              <ul className="mt-6 flex flex-1 flex-col gap-3">
                {tier.features.map((f) => (
                  <li key={f} className="flex min-w-0 items-start gap-2 text-sm text-slate-300">
                    <Check className="mt-0.5 h-4 w-4 shrink-0 text-emerald-400" aria-hidden />
                    {f}
                  </li>
                ))}
              </ul>

              <div className="mt-8">
                <DemoCta width="full" />
              </div>
            </article>
          </Reveal>
        ))}
      </div>

      <p className="mt-8 text-center text-sm text-slate-500">{LANDING_PRECO_PERSONALIZADO}</p>
    </section>
  );
}
